/**
 * A sales order needs at least one configured product or one free line with
 * a description and a quantity.
 */
export function hasSalesOrderLines(lines = []) {
  return (Array.isArray(lines) ? lines : []).some((line) => {
    if (line?.kind === 'product') return !!line.product_id && Number(line.quantity) > 0;
    if (line?.kind === 'manual') {
      return !!String(line.description || '').trim() && Number(line.quantity) > 0;
    }
    return false;
  });
}

/**
 * Editor lines → API payload: configured products and free lines.
 */
export function splitSalesOrderLines(lines = []) {
  const list = Array.isArray(lines) ? lines : [];
  const products = list
    .filter((line) => line.kind === 'product' && line.product_id)
    .map((line) => ({
      product_id: line.product_id,
      configuration: line.configuration || {},
      quantity: Number(line.quantity) || 1,
      ...(line.pricing ? { pricing: line.pricing } : {}),
      ...(line.hidden ? { hidden: true } : {}),
    }));
  const items = list
    .filter((line) => line.kind === 'manual')
    .map((line) => ({
      description: String(line.description || '').trim(),
      quantity: Number(line.quantity) || 0,
      unit_price: Number(line.unit_price) || 0,
      ...(line.hidden ? { hidden: true } : {}),
    }))
    .filter((line) => line.description && line.quantity > 0);
  return { products, items };
}
